// Central contact info for GORILLAS REBOQUE
export const CONTACT = {
  brand: "GORILLAS REBOQUE",
  cnpj: "30.668.330/0001-10",
  cnpjRaw: "30668330000110",
  phoneDisplay: "(91) 98273-6261",
  phoneRaw: "5591982736261", // for wa.me + tel
  telHref: "tel:+5591982736261",
  email: "gorillasreboque@gmail.com",
  waMessage:
    "Ola%2C%20preciso%20de%20guincho%20agora.%20Vim%20pelo%20site%20da%20GORILLAS%20REBOQUE.",
};

export const waHref = `https://wa.me/${CONTACT.phoneRaw}?text=${CONTACT.waMessage}`;

export const ASSETS = {
  logo:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_b2fea7fa-331b-4fe7-967a-3045cfd9070a/artifacts/861ypkuu_WhatsApp%20Image%202026-07-20%20at%2012.10.55.jpeg",
  car:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_b2fea7fa-331b-4fe7-967a-3045cfd9070a/artifacts/reklye64_WhatsApp%20Image%202026-07-20%20at%2012.10.55%20%281%29.jpeg",
  suv:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_b2fea7fa-331b-4fe7-967a-3045cfd9070a/artifacts/lkvskcvx_WhatsApp%20Image%202026-07-20%20at%2012.11.01.jpeg",
  moto:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_b2fea7fa-331b-4fe7-967a-3045cfd9070a/artifacts/ugvygsbq_WhatsApp%20Image%202026-07-20%20at%2012.11.03%20%281%29.jpeg",
  sedan:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_b2fea7fa-331b-4fe7-967a-3045cfd9070a/artifacts/zm3yppst_WhatsApp%20Image%202026-07-20%20at%2012.10.58.jpeg",
  banner:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_reboque-belem/artifacts/nn22jji8_WhatsApp%20Image%202026-07-23%20at%2014.09.29.jpeg",
};
